export enum RouterSegments {
  SERVICES = 'services',
  TENANTS = 'tenants',
  COSTMGMT = 'cost',
  MY_ACCOUNT = 'my-account',
  CATALOGUE = 'catalogue',
  MY_SANDBOX = 'my-sandbox',
  INSPIRATION_LOUNGE = 'inspiration-lounge',
  SUPER_FINANCE_APP = 'super-finance-app',
  TEEN_MATE_APP = 'teen-mate-app',
  FITNESS_SAVINGS_APP = 'fitness-savings-account',
  INSTANCES = 'instances',
  VIRTUAL_COO = 'virtual-coo',
  INDULGE = 'indulge',
  BLUEPRINTS = 'blueprints',
  TENANT = 'tenant',
  TENANT_LIST = 'tenants',
  INSTANCE = 'instance',
  SOLUTION = 'solutions',
  SOLUTIONS = 'updates-solution',
  EXTERNAL_INSTANCE = 'external-instance',
  SUBSCRIPTIONS = 'subscription',
  SERVICE_DEFINITION = 'blueprints',
  CERTIFICATE = 'certificate',
  EXTEND = 'extend',
  CONTINUOUS_UPDATE = 'updates',
  VERSIONS = 'versions',
  EXTERNAL_PACKAGE = 'external-package',
  UPDATE = 'update',
  DISASTER_RECOVERY = 'disaster-recovery',
  UNAUTHORIZED = 'unauthorized',
  DASHBOARD = 'dashboard',
  DEFINITION = 'definition',
  ROLES = 'roles',
  PERMISSIONS = 'permissions',
  GROUPS = 'groups',
  COMPONENT_UPDATE = 'component',
  SHARED_SERVICES = 'shared-services',
  RESOURCE_CONFIG = 'resource-config',
  UPDATE_RESOURCE_CONFIG = 'update-resource-config',
  JUMPBOX = 'jumpbox',
  EDGE_NETWORK = 'edge-network',
  PERMISSION_ERROR = 'service-unavailable',
  SCHEDULE = 'schedule',
  CREATE = 'create',
  TYPE = 'type',
  CREATE_TENANT = 'create-tenant-new',
  TENANT_ONBOARDING = 'tenant-onboarding',
  CUSTOM_IMAGE = 'custom-image',
  ENVIRONMENT = 'environment',
  CREATE_RUNBOOK = 'create-runbook',
  CREATE_SCHEDULE = 'create-schedule',
  JOB = "job",
  EDIT_SCHEDULE = 'edit-schedule',
  EDIT_RUNBOOK = 'edit-runbook',
  TENANT_DETAILS = 'tenant-details',
  DEPLOY_SIZING = 'deploy-sizing',
  CREATE_SIZING = 'create-sizing',
  EDIT_SIZING = 'edit-sizing',
  SIZING = 'sizing'
}
